export default {
  SET_REDIRECT_PATH(state, path) {
    state.redirectPath = path
  },
}
